import {createSlice} from '@reduxjs/toolkit'
import packageJson from "../../package.json";
import {getRalColorsOptions} from "../misc/helpers";
import {options} from "../forms/AdvancedConfigurationForm";


const initialState = {
    dimensions: null,
    config: {
        product: null,
        width: 100,
        height: 210,
        align: 'right',
        topEnabled: true,
        depth: options.depth[0].value,
        openingDirection: 'right',
        openingType: 'inside',
        color: getRalColorsOptions().find(o => o.value === '8003'),
        type: options.type[0].value,
        doorstep: 'drewniany',
        glass: 'lustro_weneckie',
        lock: 'standard',
        border: 'czarny',
        handle: 'standard',
        biggerBottomBorder: false,
        topBorder: 0,
        bottomBorder: 0,
    },
    customerDetails: null,
    products: [],
}


export const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        setDimensions: (state, action) => {
            state.dimensions = action.payload
        },
        setConfig: (state, action) => {
            state.config = action.payload
        },
        setCustomerDetails: (state, action) => {
            state.customerDetails = action.payload
        },
        setProducts: (state, action) => {
            state.products = action.payload
        },
        clearStore: () => initialState,
    },
})


export const {setDimensions, setConfig, setCustomerDetails, setProducts, clearStore} = mainSlice.actions

export default mainSlice.reducer
